module.exports = __webpack_public_path__ + "static/media/wpforms.719766e3.svg";